import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {Label} from "@irati/ui/src/Typography"
import {TextButton} from "@irati/ui/src/Button"

const StyledLabel = styled(Label)`
  padding-bottom: 9px;
  margin: 0 3px;
  ${({selected, theme}) => selected && `border-bottom: 5px solid ${theme.colors.brand.default};`}
`

const WrapperLabel = (props) => (
  <TextButton onClick={props.onClick}>
    <StyledLabel uppercase bold={props.selected} {...props} />
  </TextButton>
)

WrapperLabel.propTypes = {
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired
}

export default WrapperLabel
